import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  
  // Use useLocation to determine the current path
  const location = useLocation();
  
  // Check if current path is a case study page (handles dynamic routes)
  const isCaseStudyPage = location.pathname.startsWith('/caseStudy');
  
  // const layoutStyles = {
  //   layout: {
  //     minHeight: '100vh',
  //     display: 'flex',
  //     flexDirection: 'column'
  //   },
  //   smoothWrapper: {
  //     flex: 1,
  //     display: 'flex',
  //     flexDirection: 'column'
  //   },
  //   smoothContent: {
  //     flex: 1,
  //     display: 'flex',
  //     flexDirection: 'column'
  //   },
  //   main: {
  //     paddingTop: '80px', // Account for fixed header
  //     flex: 1, // Take remaining space
  //     backgroundColor: 'rgba(241, 237, 228, 1)',
  //     paddingBottom: isCaseStudyPage ? '0' : '2rem' // Remove bottom padding for case study pages
  //   }
  // };

  return (
    <div className="layout" >
      <Header />
      <div id="smooth-wrapper" >
        <div id="smooth-content" >
          <main >
            {children}
          </main>
          {/* Show Footer only if not on any case study page */}
          {!isCaseStudyPage && <Footer />}
        </div>
      </div>
    </div>
  );
};

export default Layout;